import React, { FC } from 'react';
import { Button, Modal, Space } from 'antd';
import { IModal } from 'common/models/model.interface';
import rentalPropertyService from 'common/services/rental-property-service/rental-property.service';
import { ReactComponent as ApproveIcon } from 'assets/icons/approve.svg';
import { notification } from 'common/utils/notification';
import styles from '../rental-portal.module.scss';

const ApproveRentalPropertyModal: FC<IModal<{ rentalPropertyId: number }, any>> = ({ isOpen, onClose, title, initData }) => {
  const hideModal = (isSuccess: boolean) => {
    notification.destroy();
    if (onClose) {
      onClose(isSuccess);
    }
  };

  const handleApprove = () => {
    if (!initData?.rentalPropertyId) {
      console.error('Rental property id is empty');
      return;
    }

    rentalPropertyService
      .approve(initData.rentalPropertyId)
      .then(() => hideModal(true))
      .catch(() => {});
  };

  return (
    <Modal centered title={title} width={350} open={isOpen} wrapClassName="custom-modal" closable={false}>
      <Space className="confirm-modal-body">Are you sure you want to approve this rental property?</Space>
      <Space className="footer">
        <Button type="link" onClick={() => hideModal(false)} className="eiq-button">
          Cancel
        </Button>
        <Button type="primary" onClick={handleApprove} icon={<ApproveIcon />} className={`${styles.approveButton} eiq-button`}>
          Approve
        </Button>
      </Space>
    </Modal>
  );
};

export default React.memo(ApproveRentalPropertyModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});
